import React from 'react';
import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect, useRef } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import Form from '../../../containers/Form/Form'
import Select from "../../../containers/Form/Select";

// import Moment from 'moment';
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_flirtkings_dashboard, tool_flirtkings_invoice_save, tool_flirtkings_invoice_delete } from "../../../app/apiEndpoints" //tool_lp_dashboard_boost
import ConfirmDialog from '../../../containers/ConfirmDialog'
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'
import Input from '../../../containers/Form/Input';
import Button from '../../../containers/Form/Button';
import { parseISO } from "date-fns";

import Moment from 'moment';

//import { CSVLink } from "react-csv";


const FlirtKingsDashboard = (props) => {
    const toolID = 21
    const [tool, setTool] = useState({})

    //const [hasErrors, setHasErrors] = useState(false)
    //const [status, setStatus] = useState(0)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    const [stats, setStats] = useState([])
    const [invoices, setInvoices] = useState([])

    const [inputValue, setInputValue] = useState({ invoiceID: 0, invoiceDate: "", invoiceAmount: "", invoiceNum: "" });
    const [errors, setErrors] = useState({ invoiceID: "", invoiceDate: "", invoiceAmount: "", invoiceNum: "" });
    const { invoiceID, invoiceDate, invoiceAmount, invoiceNum } = inputValue;
    const [formMessage, setFormMessage] = useState('')
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const canEdit = isSysadmin
    const isEditing = parseInt(invoiceID) > 0
    const formRef = useRef(null)

    //filters
    const [curAccount, setCurAccount] = useState(1)
    
    const tableFields = ["Date", "# Regs", "Revenue", "Running Balance", "Invoice Amount", "Invoice", "Total Spend"]
    const tableFieldName = ["datestr", "total_rev", "sum_revenue", "balance", "invoice_amount", "invoice_num", "spend"]
    const invFields = ["Date", "Invoice Amount", "Invoice"]

    const [sortField, setSortField] = useState('total_requests')
    const [sortDirection, setSortDirection] = useState(1)
    const tableID = "invoice"

    const accountTypes = [
        {ID: 1, NAME: "Casual 861"}, 
        {ID: 2, NAME: "Trans Old 813"},
        {ID: 3, NAME: "Trans New 889"},
        {ID: 4, NAME: "Granny 883"},
        {ID: 5, NAME: "Gay 864"},
        {ID: 6, NAME: "AdNexo Straight Open Filter"},
        {ID: 7, NAME: "AdNexo Molly"},
        {ID: 8, NAME: "AdNexo Trans Open Filter"},
        {ID: 9, NAME: "AdNexo Trans Molly"},
    ]

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getStats = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_flirtkings_dashboard, { 'requester': userID, 'company': companyID, 'account': curAccount })
                setStats(data.stats)
                if(data.invoices) setInvoices(data.invoices)
            }
        }
            getStats()
    }, [userID, companyID, curAccount])

    // const genRevReport = async (e) => {
    //     e.preventDefault()
    //     setRevCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 1, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRevCsv(csvData.revcsv)
    //         setRevCsvStatus(2)
    //     }
    // }

    // const genRegReport = async (e) => {
    //     e.preventDefault()
    //     setRegCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 2, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRegCsv(csvData.revcsv)
    //         setRegCsvStatus(2)
    //     }
    // }

    const tableData = (type) => {
        let values = stats

        // Sort values before mapping
        values = [...values].sort((a, b) => {
            // Always move "TOTAL" to the bottom
            if (a.path === "TOTAL") return 1;
            if (b.path === "TOTAL") return -1;

            let aValue = a[sortField];
            let bValue = b[sortField];

            // Convert to number if field is numeric
            if (['sum_revenue','balance','invoice_amount','spend'].includes(sortField)) {
                aValue = parseFloat(aValue);
                bValue = parseFloat(bValue);
            } else {
                aValue = String(aValue).toLowerCase();
                bValue = String(bValue).toLowerCase();
            }

            if (aValue < bValue) return sortDirection === 0 ? -1 : 1;
            if (aValue > bValue) return sortDirection === 0 ? 1 : -1;
            return 0;
        });

        let rows = [];
        values.forEach(row => {
            rows.push({'id': row.datestr, 'values': [
                //row.report_date,
                row.datestr,
                row.total_rev,
                row.sum_revenue ? '$' + parseFloat(row.sum_revenue).toFixed(4) : '',
                row.balance ? (parseFloat(row.balance) < 0 ? '($' + parseFloat(row.balance*-1).toFixed(4) + ')' : '$' + parseFloat(row.balance).toFixed(4)) : '',
                row.invoice_amount ? '$' + parseFloat(row.invoice_amount).toFixed(4) : '',
                row.invoice_num,
                row.spend ? '$' + parseFloat(row.spend).toFixed(4) : ''
            ]});
        });
        return rows
    }

    const invData = (type) => {
        let values = invoices

        let rows = [];
        values.forEach(row => {
            rows.push({'id': row.id, 'values': [
                row.invoice_date,
                row.invoice_amount ? '$' + parseFloat(row.invoice_amount).toFixed(4) : '',
                row.invoice_num,
            ]});
        });
        return rows
    }

    const sortData = (field, direction) => {
        let index = tableFields.indexOf(field)

        setSortField(tableFieldName[index])
        setSortDirection(direction)
    }


    const clearForm = () => {
        setInputValue({ invoiceID: 0, invoiceDate: "", invoiceAmount: "", invoiceNum: "" })
        setErrors({ invoiceID: "", invoiceDate: "", invoiceAmount: "", invoiceNum: "" })
        setFormMessage('')
        setShowConfirmDelete(false)
    }

    const filterAccount = (e) => {
        let { value } = e.target;
        setStats([])
        setInvoices([])
        clearForm()
        setCurAccount(value)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue((prev) => ({
          ...prev,
          [name]: value,
        }));
    };
    
    const handleError = (field, error) => {
          setErrors((prev) => ({
              ...prev,
              [field]: error,
          }));
    };

    const selectInvoice = (e) => {
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`${tableID}_`, "")
        const foundItem = invoices.find(item => item.id === rowID);
        if(!foundItem) return
        setFormMessage('')
        setInputValue((prev) => ({
          ...prev,
          'invoiceID': rowID,
          'invoiceNum': foundItem.invoice_num,
          'invoiceAmount': foundItem.invoice_amount,
          invoiceDate: foundItem.invoice_date ? parseISO(foundItem.invoice_date) : null,
        }));
        if(formRef.current) formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    const startAddInvoice = (e) => {
        e.preventDefault()
        clearForm()
    }

    const confirmDeleteInvoice = (e) => {
        e.preventDefault()
        setShowConfirmDelete(true)
    }

    const deleteInvoice = async () => {
        setShowConfirmDelete(false)
        const data = await toolsAPICall(tool_flirtkings_invoice_delete, {
            'requester': userID, 'company': companyID, 'account': curAccount, 'id': invoiceID
        })

        if(data.error) {
            setFormMessage(data.error)
            return
        }

        if(data.stats) setStats(data.stats)
        if(data.invoices) setInvoices(data.invoices)
        clearForm()
        setFormMessage("Invoice deleted")
    }

    const saveInvoice = async (e) => {
        e.preventDefault()
        
        setFormMessage('')
        let formErrors = []
        for (const field of Object.entries(errors)) {
            const error = field[1]
            if(error.length > 0) formErrors.push(error)
        }
        if(formErrors.length > 0) { 
            setFormMessage(formErrors.join('<br/>'))
            return
        }

        if(invoiceDate.length === 0) {
            formErrors.push("You must select an Invoice Date")
        }
        if(invoiceAmount.length === 0) {
            formErrors.push("You must enter an Invoice Amount")
        }
        if(invoiceNum.length === 0) {
            formErrors.push("You must select a Invoice Number")
        }
        if(formErrors.length > 0) { 
            setFormMessage(formErrors.join('<br/>'))
            return
        }

        const data = await toolsAPICall(tool_flirtkings_invoice_save, {
            'requester': userID, 'company': companyID, 'account': curAccount, 'invoice_date': (Moment(invoiceDate).format('YYYY-MM-DD')), 'amount': invoiceAmount, 'invoice_num': invoiceNum, 'id': invoiceID
        })

        //if successful, delete from project object
        if(data.error) {
            setFormMessage(data.error)
            return
        } 
        else {
            if(data.stats) setStats(data.stats)
            if(data.invoices) setInvoices(data.invoices)
            setFormMessage(isEditing ? "Invoice updated" : "Invoice saved")
        }
    }

    if(!tool) return <></>

    if(!stats) return <>No Data</>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
        <Card>

            <Card.Header>
                <Row>
                    <Col md={8}>
                        <h4 className="title">{tool.tool_name}</h4>
                        {tool.description && <p className="category">{tool.description}</p> }
                    </Col>
                    <Col md={4} className="text-right">
                        <Select
                            value={curAccount}
                            label="Account"
                            name="account"
                            formValues={accountTypes}
                            useDefault={false}
                            onChange={filterAccount}
                            validate="numeric|required"
                            colSize="6"
                        />      
                    </Col>
                </Row>
            </Card.Header>
                <Form description={tool.description} noCard={true} >
                    <Row>
            {canEdit &&
                        <Col md={6} ref={formRef}>
                            <strong>{isEditing ? 'Edit Invoice' : 'Add Invoice'}</strong>

                            <Input
                                type="date"
                                value={invoiceDate}
                                placeholder="Invoice Date"
                                label="Invoice Date"
                                name="invoiceDate"
                                onChange={handleChange}
                                onError={handleError}
                                validate="date|required"
                                colSize="6"
                                readOnly={!canEdit}
                            />
                            
                            <Input
                                type="text"
                                value={invoiceAmount}
                                placeholder="Invoice Amount"
                                label="Invoice Amount"
                                name="invoiceAmount"
                                onChange={handleChange}
                                onError={handleError}
                                validate="currency|required"
                                colSize="4"
                                readOnly={!canEdit}
                            />
                            
                            <Input
                                type="text"
                                value={invoiceNum}
                                placeholder="Invoice Number"
                                label="Invoice Number"
                                name="invoiceNum"
                                onChange={handleChange}
                                onError={handleError}
                                validate="numeric|required"
                                colSize="4"
                                readOnly={!canEdit}
                            />

                            {formMessage.length > 0 && <p>{formMessage}</p> }

                            {canEdit && <Button title={isEditing ? 'Edit Invoice' : 'Save Invoice'} className="primary" onClick={saveInvoice}  />}
                            {isEditing && canEdit && <Button title="Delete Invoice" className="danger" onClick={confirmDeleteInvoice} />}
                        </Col>
            }
                        <Col md={6}>
                            <Row>
                                <Col md={6}>
                                    <strong>Invoices</strong>
                                </Col>
                                <Col md={6} className="text-right">
                                    {canEdit && <Button title="Add Invoice" className="default" onClick={startAddInvoice} />}
                                </Col>
                            </Row>
                            <DataTable hover={true} tableID={tableID} onClick={selectInvoice} fieldNames={invFields} dataRows={invData()} tableSettings={tableTypes.None} hideTotal={true} />
                    </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                        <CardHeader title="Balance Tracking" description="Daily Balance Tracking" />
                        <DataTable hover={true} tableID="suc" fieldNames={tableFields} dataRows={tableData(1)} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Date' />
                        
                        </Col>
                    </Row>
                </Form>
            </Card>
        <ConfirmDialog show={showConfirmDelete} title="Delete Invoice" message={`Are you sure you want to delete invoice #${invoiceNum}?`} onClose={() => setShowConfirmDelete(false)} onConfirm={deleteInvoice} />
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(FlirtKingsDashboard), "FlirtKings Dashboard"));